import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import { NavigationPromptModal } from '../NavigationPromptModal/NavigationPromptModal';
import { useHistory } from 'react-router-dom';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useDispatch, useSelector } from 'react-redux';
import { Actions, Thunks } from '../../actions';
import { isDataLoaded } from '../../types';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { DECIMAL_NUMBER, IP_ADDRESS, ALPHA_NUMBERIC, ONLY_NUMBER, RESTRICT_SPEC_WITHOUT_SPACE_REGEX, RESTRICT_BLG_DEVICE_SPACE_REGEX } from '../../constants';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { pushRate } from '../../constants/device-data';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { StarfishDeviceSelectors } from '../../selectors/starfish-device-selectors ';
import { StarfishDeviceRegistration } from '../../types/device';
import { useAuthHelper } from '../AuthContextProvider';
import { useDeviceMaster } from '../../data/DataProviders/DeviceMasterProvider';
import { ConfirmationPopUp } from '../../components/ConfirmationPopUp/ConfirmationPopUp';
import { StarfishDeviceActions } from '../../actions/actions/starfish-device-actions';
export const AddStarfishDevice: React.FC<{
    onCancel: Function;
    siteId: string;
    organizationName: string;
    device: string;
    deviceTypeValue: string;
    deviceTypeList: Array<{ key: string; value: string; gatewayProfileId: string; netmask: number }>;
}> = (props): JSX.Element => {
    const { t } = useLanguageLocale();
    const history = useHistory();
    const classes = deviceStyles();
    const deviceMasterData = useDeviceMaster();
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    const authHelper = useAuthHelper();
    const currentAppRoute = useCurrentAppRoute();
    const [gatewayDevice, setGatewayDevice] = useState<StarfishDeviceRegistration | null>(null);
    const StarfishDeviceState = useSelector(StarfishDeviceSelectors.deviceRegistration);
    //const [guidAddressError, setGUIDAddressError] = React.useState(false);
    const [ipAddressError, setIPAddressError] = React.useState(false);

    useEffect(() => {
        dispatch(StarfishDeviceActions.StarfishGatewayDeviceRegistrationUnmounted());
    }, []);

    const onChangeValues = (value: string | number, type: string): void => {
        if (gatewayDevice) {
            const deviceObj: any = { ...gatewayDevice };
            deviceObj[`${type}`] = value;
            setGatewayDevice(deviceObj);
        }
    };
    const onChangeName = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (RESTRICT_BLG_DEVICE_SPACE_REGEX.test(e.target.value)) onChangeValues(e.target.value, 'name');
    };

    // const onChangeGuid = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    //     onChangeValues(e.target.value, 'deviceId');

    // };
    const onChangeIPAddress = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (e.target.value === '' || DECIMAL_NUMBER.test(e.target.value)) {
            setIPAddressError(false);
            onChangeValues(e.target.value, 'deviceIp');
        }
    };
    const onChangeSerial = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (e.target.value === '' || ALPHA_NUMBERIC.test(e.target.value)) {
            onChangeValues(e.target.value === '' ? '' : e.target.value.toString(), 'serial');
        }
    };
    const onChangeMac = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.target.value === '' || RESTRICT_SPEC_WITHOUT_SPACE_REGEX.test(e.target.value)) {
            onChangeValues(e.target.value, 'mac');
        }
    };
    const onChangeValuesPush = (e: any): void => {
        if (e.target.value === '' || ONLY_NUMBER.test(e.target.value)) {
            onChangeValues(e.target.value === '' ? '' : Number(e.target.value), 'pushRate');
        }
    };

    const onDevicesCancel = (): void => {
        props.onCancel();
    };
    const navigateToPxwDeviceProfile = (): void => {
        dispatch(StarfishDeviceActions.StarfishGatewayDeviceRegistrationUnmounted());
        if (currentAppRoute.type === 'AddDevice' && gatewayDevice) {
            pushAppRoute(history, {
                type: 'StarfishDeviceProfile',
                orgId: currentAppRoute.orgId,
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
                deviceId: StarfishDeviceState.id,
            });
        }
    };

    const handleClose = (): void => {
        navigateToPxwDeviceProfile();
        dispatch(Actions.StarfishDevices.StarfishGatewayDeviceRegistrationUnmounted());
    };

    const isDirty =
        (gatewayDevice &&
            (gatewayDevice.name !== '' ||
                // gatewayDevice.deviceId !== '' ||
                gatewayDevice.deviceIp !== '')) ||
        false;

    const isDisable =
        gatewayDevice?.name.trim() !== '' &&
        gatewayDevice?.deviceIp.trim() !== '' && //GUID
        gatewayDevice?.pushRate !== 0;

    const isSubmitDisable = (): boolean | undefined => {
        if (!StarfishDeviceState.starfishgatewayLoading && Boolean(isDisable)) return true;
    };

    useEffect(() => {
        dispatch(StarfishDeviceActions.StarfishGatewayDeviceMasterData(true));
        if (props.siteId !== '' && isDataLoaded(deviceMasterData.deviceTypeData) && props.deviceTypeValue !== '') {
            const gatewayObj = props.deviceTypeList.find((x) => x.key.toLowerCase() === props.deviceTypeValue.toLowerCase());
            const gatewayDeviceValues: StarfishDeviceRegistration = {
                siteId: props.siteId,
                name: '',
                serial: '',
                deviceIp: '',
                deviceAddress: '',
                mac: '',
                deviceProfileId: gatewayObj?.gatewayProfileId,
                pushRate: 5,
            };
            setGatewayDevice(gatewayDeviceValues);
        }
    }, [props.siteId, deviceMasterData.deviceTypeData]); //eslint-disable-line react-hooks/exhaustive-deps
    const onSubmit = (): void => {
        let checkIPAddress = true;

        if (gatewayDevice && gatewayDevice.deviceProfileId) {
            if (!IP_ADDRESS.test(gatewayDevice?.deviceIp)) {
                setIPAddressError(true);
                checkIPAddress = false;
            } else {
                setIPAddressError(false);
                checkIPAddress = true;
            }
            if (checkIPAddress) {
                const starfishgatewayDeviceData = {
                    name: gatewayDevice.name,
                    deviceIp: gatewayDevice.deviceIp,
                    siteId: props.siteId,
                    serial: gatewayDevice.serial,
                    mac: gatewayDevice.mac,
                    deviceProfileId: gatewayDevice.deviceProfileId,
                    pushRate: gatewayDevice.pushRate,
                };
                dispatch(
                    Thunks.StarfishDevice.StarfishDeviceRegistration(starfishgatewayDeviceData, authHelper, addToast)
                );
            }
        }
    };

    return (
        <Box>
            {gatewayDevice && (
                <>
                    <Box>
                        <Box className={classes.padding8}>
                            <TextField
                                inputProps={{ 'data-testid': 'device-name', maxLength: 24 }}
                                className={classes.fullWidth}
                                required
                                variant="filled"
                                value={gatewayDevice.name}
                                id="DeviceName"
                                label="Connected Device Name"
                                onChange={(e): void => onChangeName(e)}
                            />
                        </Box>

                        <Box className={classes.padding8}>
                            <TextField
                                inputProps={{ 'data-testid': 'ip-address' }}
                                className={classes.fullWidth}
                                required
                                variant="filled"
                                value={gatewayDevice.deviceIp}
                                id="deviceIp"
                                label="IP Address"
                                onChange={(e): void => onChangeIPAddress(e)}
                                error={ipAddressError}
                                helperText={ipAddressError ? 'Invalid IP Address' : ''}
                            />
                        </Box>
                        <Box className={classes.padding8}>
                            <TextField
                                inputProps={{ 'data-testid': 'serial', maxLength: 255 }}
                                className={classes.fullWidth}
                                variant="filled"
                                value={gatewayDevice.serial}
                                id="DeviceSerial"
                                label="Serial"
                                onChange={(e): void => onChangeSerial(e)}
                            />
                        </Box>
                        <Box className={classes.padding8}>
                            <TextField
                                inputProps={{ 'data-testid': 'mac' }}
                                className={classes.fullWidth}
                                variant="filled"
                                value={gatewayDevice.mac}
                                id="mac"
                                label="Mac"
                                onChange={(e): void => onChangeMac(e)}
                            />
                        </Box>
                        <Box className={classes.padding8}>
                            <FormControl variant="filled" required fullWidth>
                                <InputLabel id="pushRate" data-testid="pushRate">
                                    Publish Rate
                                </InputLabel>
                                <Select
                                    label="pushRate"
                                    value={gatewayDevice.pushRate}
                                    required
                                    inputProps={{ 'data-testid': 'pushRate-dd', width: '50%' }}
                                    onChange={(e): void => {
                                        onChangeValuesPush(e);
                                    }}
                                >
                                    {pushRate.map((data: { key: string; value: string }, index: number) => (
                                        <MenuItem key={index} value={data.key} data-testid={`pushRate${index}`}>
                                            {data.value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>

                    <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '24px 8px' }}>
                        <Button
                            style={{ marginRight: 16 }}
                            variant="outlined"
                            color="primary"
                            data-testid="cancel-device"
                            onClick={(): void => onDevicesCancel()}
                        >
                            {t('ACTIONS.CANCEL')}
                        </Button>
                        <Button
                            variant="contained"
                            disabled={!isSubmitDisable()}
                            startIcon={
                                StarfishDeviceState.starfishgatewayLoading ? (
                                    <CircularProgress size="1rem" style={{ color: 'white' }} />
                                ) : (
                                    <></>
                                )
                            }
                            color="primary"
                            data-testid="add-device-button"
                            onClick={onSubmit}
                        >
                            {t('ACTIONS.SUBMIT')}
                        </Button>
                    </Box>
                </>
            )}
            {StarfishDeviceState.starfishgatewaySuccess && (
                <ConfirmationPopUp
                    title="Submission Successful!"
                    body={
                        <>
                            <Typography variant="subtitle1">
                                Your Connected Device is being remotely configured.
                            </Typography>
                            <Typography variant="subtitle1">
                                The total configuration time is dependent on your Gateway&apos;s cellular signal
                                strength.
                            </Typography>
                        </>
                    }
                    okButtonText={'OK'}
                    show={StarfishDeviceState.starfishgatewaySuccess}
                    handleOk={handleClose}
                    okButtonShow={true}
                    width="xs"
                ></ConfirmationPopUp>
            )}
            {!StarfishDeviceState.starfishgatewaySuccess && <NavigationPromptModal isDirty={isDirty} />}
        </Box>
    );
};
